/**
 * Created by razial on 05.06.2026.
 */

const FilteredDataSource = function (dataSource, filter) {
    cleverapps.EventEmitter.call(this);

    this.dataSource = dataSource;
    this.filter = filter;
    this.switching = false;

    this.dataSource.on("add", (row) => {
        if (this.isAccepted(row)) {
            this.trigger("add", row);
        }
    }, this);
    this.dataSource.on("remove", (id, silent) => this.trigger("remove", id, silent), this);
    this.dataSource.on("reorder", () => this.trigger("reorder"), this);
    this.dataSource.on("updateAll", (force) => this.trigger("updateAll", force), this);
};

FilteredDataSource.prototype = Object.create(cleverapps.EventEmitter.prototype);
FilteredDataSource.prototype.constructor = FilteredDataSource;

FilteredDataSource.prototype.destructor = function () {
    runCleaners(this);
};

FilteredDataSource.prototype.isAccepted = function (row) {
    return !this.filter || this.filter(row);
};

FilteredDataSource.prototype.getData = function () {
    return this.dataSource.getData().filter(this.isAccepted.bind(this));
};

FilteredDataSource.prototype.setFilter = function (filter) {
    const oldRows = this.getData();
    this.filter = filter;
    const newRows = this.getData();

    this.switching = true;
    cleverapps.substract(oldRows, newRows, (row) => row.id).forEach((row) => this.trigger("remove", row.id, true));
    cleverapps.substract(newRows, oldRows, (row) => row.id).forEach((row) => this.trigger("add", row));
    this.switching = false;
};

FilteredDataSource.prototype.isSwitching = function () {
    return this.switching;
};
